import React from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { PHONE_TEL } from "@/data/site";
import { track } from "@/lib/analytics";

export const MobileCTABar = () => (
  <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-testid="mobile-cta-bar">
    <div className="grid grid-cols-2">
      <a href={`tel:${PHONE_TEL}`} className="flex flex-col items-center justify-center py-2.5 text-emerald-900 border-r border-slate-100"
        data-testid="mobilebar-call" onClick={() => track("phone_click", { source: "mobile_bar" })}>
        <Phone size={22} /><span className="text-xs font-semibold mt-0.5">Chiama</span>
      </a>
      <Link to="/offerta" className="flex flex-col items-center justify-center py-2.5 text-white" style={{ backgroundColor: "var(--sc-amber)" }}
        data-testid="mobilebar-prenota" onClick={() => track("cta_click", { cta: "prenota_prova", source: "mobile_bar" })}>
        <CalendarCheck size={22} /><span className="text-xs font-bold mt-0.5">Ordina</span>
      </Link>
    </div>
  </div>
);
